import useDebounce from "hooks/others/useDebounce";
import { useQuery } from "react-query";
import { GetAttendanceLog } from "services/workSchedule";

interface UseGetAttendanceLogProps {
  search: string;
  user_id?: number;
}

export default function useGetAttendanceLog({user_id, search }: UseGetAttendanceLogProps, options?: any) {
  const { newParam: searchParam } = useDebounce(search);

  return useQuery(
    ["attendance-log", user_id, searchParam],
    () => GetAttendanceLog({user_id , search: searchParam}),
    {
      keepPreviousData: true,
      ...options
    }
  );
}
